import { HttpEvent, HttpHandlerFn, HttpRequest, HttpResponse } from "@angular/common/http";
import { inject } from "@angular/core";
import { catchError, map, Observable, throwError } from "rxjs";
import { WebLoadingService } from "../web-loading-service/web-loading.service";

/**
 * Interceptor to manage loading state for HTTP requests.
 * It sets the loading state to true when a request is made and false when the response is received or an error occurs.
 * If the request has a 'No-Loading' header, it skips the loading state management.
 */
export function loadingInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) :Observable<HttpEvent<unknown>>  {

  if (req.headers.has('No-Loading')) {
    return next(req.clone({ headers: req.headers.delete('No-Loading') }));
  }
  const authService = inject(WebLoadingService);
  authService.setLoading(true, req.url);

  return next(req)
    .pipe(catchError((error) => {
      authService.setLoading(false, req.url);
      return throwError(() => error);
    }))
    .pipe(map((evt: HttpEvent<unknown>) => {

      if (evt instanceof HttpResponse) {
        authService.setLoading(false, req.url);
      }
      return evt;
    }));
  }